import jwt from 'jwt-decode';
import { useLocation, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { TokenSchema } from '../utils/TokenSchema';
import empresasService from 'services/empresas';
import usuariosService from 'services/usuarios';
import { AlertaError, AlertaExito, AlertaWarning } from 'utils/Alertas';
import { RUTAS } from 'const/Rutas';

const ESTADOS = {
  ERROR_INICIAL: 'ERROR_INICIAL',
  LOADING: 'LOADING',
  PRE_CONFIRMACION: 'PRE_CONFIRMACION',
  CONFIRMACION: 'CONFIRMACION',
  SOLICITUD_RECHAZADA: 'SOLICITUD_RECHAZADA',
  SOLICITUD_APROBADA: 'SOLICITUD_APROBADA',
  REGISTRO_USUARIO: 'REGISTRO_USUARIO'
};

export const useConfirmarRegistroAdministracion = () => {
  const history = useHistory();
  const [vista, setVista] = useState(ESTADOS.LOADING);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [terminosAceptados, setTerminosAceptados] = useState(false);
  const [data, setData] = useState();
  const [token, setToken] = useState();

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [ingresandoDatosUsuario, setIngresandoDatosUsuario] = useState(false);

  const onConfirmarSolicitud = async accion => {
    try {
      setIsSubmiting(true);
      const response = await empresasService.confirmarAdministracion({
        token: token,
        accion: accion
      });

      if (response.status === 200 && response.data === true) {
        if (accion === 'aceptar') {
          setVista(ESTADOS.SOLICITUD_APROBADA);
        } else if (accion === 'rechazar') {
          setVista(ESTADOS.SOLICITUD_RECHAZADA);
        }
      }
    } catch (error) {
    } finally {
      setIsSubmiting(false);
    }
  };

  const onVerificacionInicial = async () => {
    try {
      const token = params.get('token');
      const data = await verificarToken(token);
      setData(data);
      setVista(ESTADOS.PRE_CONFIRMACION);
    } catch (error) {
      setVista(ESTADOS.ERROR_INICIAL);
    }
  };

  const verificarToken = async token => {
    if (!token) return null;
    const objetoDecifrado = jwt(token);
    if (!objetoDecifrado.exp) throw new Error('Token inválido'); // Si no hay campo exp, considerarlo inválido
    const currentTime = Math.floor(Date.now() / 1000);
    if (objetoDecifrado.exp < currentTime) throw new Error('Token expirado');
    // Si el token ha expirado, considerarlo inválido
    else {
      const response = await TokenSchema.validate(objetoDecifrado, {
        abortEarly: false
      });
      setToken(token);
      return response;
    }
  };

  const autoRegistro = async request => {
    try {
      setIsSubmiting(true);
      const response = await usuariosService.autoRegistro(request);
      const { data } = response;
      if (data.error) {
        AlertaWarning(data.error.mensaje);
        return;
      }
      if (response.status === 200) {
        if (request.correoElectronico !== undefined || '') {
          history.push(
            `${RUTAS.REGISTRARSE_VERIFICAR_EMAIL}?correo=${request.correoElectronico}`
          );
        } else {
          history.push(RUTAS.HOME);
        }
      }
    } catch (error) {
      AlertaError(error);
    } finally {
      setIsSubmiting(false);
    }
  };

  useEffect(() => {
    onVerificacionInicial();
  }, []);

  const onRechazarSolicitud = async () => {
    const request = {
      token: token,
      accion: 'rechazar'
    };
    try {
      setIsSubmiting(true);
      const response = await usuariosService.autoRegistro(request);
      if (response.status === 200) {
        if (response.data) {
          AlertaExito('Solicitud rechazada con éxito');
        } else {
          AlertaWarning('No se ha podido rechazar la solicitud');
        }
      }
    } catch (error) {
      AlertaError(error);
    } finally {
      setIsSubmiting(false);
    }
  };

  return {
    token,
    ESTADOS,

    data,
    vista,
    isSubmiting,
    terminosAceptados,

    setTerminosAceptados,
    setVista,

    onConfirmarSolicitud,

    ingresandoDatosUsuario,
    setIngresandoDatosUsuario,

    autoRegistro,

    onRechazarSolicitud
  };
};
